import { useEffect, useState } from "react";
import { Building2, Crown, ClipboardList, UserCog, Package, TrendingUp, IndianRupee } from "lucide-react";
import { toast } from "sonner";
import { api, money } from "../lib/api";

export default function AdminOverview({ onNavigate }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/master/stats").then(({ data }) => setStats(data)).catch(() => toast.error("Could not load admin overview"));
  }, []);

  const cards = stats ? [
    { id: "clients", label: "Total clients", value: stats.total_clients, icon: Building2, go: "clients", hint: `${stats.pro_clients} Pro · ${stats.starter_clients} Starter` },
    { id: "pro", label: "Pro subscriptions", value: stats.pro_clients, icon: Crown, go: "clients", hint: "Active Pro plans" },
    { id: "setup", label: "Pending setup requests", value: stats.pending_setup, icon: ClipboardList, go: "setup_requests", hint: "Awaiting configuration" },
    { id: "upgrades", label: "Pending upgrades", value: stats.pending_upgrades, icon: TrendingUp, go: "upgrade_requests", hint: "Starter → Pro" },
    { id: "team", label: "Team members", value: stats.team_members, icon: UserCog, go: "team", hint: "Internal reviewers" },
    { id: "packages", label: "Subscription packages", value: stats.packages, icon: Package, go: "packages", hint: "Plans you offer" },
  ] : [];

  return (
    <section className="panel module-panel" data-testid="admin-overview">
      {!stats ? (
        <div className="admin-loading">Loading admin overview…</div>
      ) : (
        <>
          <div className="mrr-banner" data-testid="admin-mrr-banner">
            <span className="mrr-icon"><IndianRupee size={22} /></span>
            <div>
              <span className="mrr-label">Monthly recurring revenue</span>
              <span className="mrr-value" data-testid="admin-mrr-value">{money(stats.mrr || 0, "INR")}</span>
              <span className="mrr-hint">{stats.pro_clients} Pro × {money(stats.pro_price || 0, "INR")} + {stats.starter_clients} Starter × {money(stats.starter_price || 0, "INR")}</span>
            </div>
          </div>
          <div className="admin-stat-grid">
            {cards.map((card) => {
              const Icon = card.icon;
              return (
                <button key={card.id} className="admin-stat-card" data-testid={`admin-stat-${card.id}`} onClick={() => onNavigate?.(card.go)}>
                  <span className="admin-stat-icon"><Icon size={18} /></span>
                  <span className="admin-stat-value" data-testid={`admin-stat-${card.id}-value`}>{card.value}</span>
                  <span className="admin-stat-label">{card.label}</span>
                  <span className="admin-stat-hint">{card.hint}</span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </section>
  );
}
